import { CepV2 } from '../types/address';
import api from './api';

export default {
  async fetchCepV2(cep: string): Promise<any> {
    return (await api.get<CepV2>(`/address/cep/v2/${cep}`))?.data;
  },
};
